import { render, staticRenderFns } from "./medicalStaffStatistics.vue?vue&type=template&id=0befa185&scoped=true&"
import script from "./medicalStaffStatistics.vue?vue&type=script&lang=js&"
export * from "./medicalStaffStatistics.vue?vue&type=script&lang=js&"
import style0 from "./medicalStaffStatistics.vue?vue&type=style&index=0&id=0befa185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befa185",
  null
  
)

export default component.exports